<template>
  <header class="header">

  </header>
</template>
<script>
export default {
    components: {
    },

    methods: {

    },
}
</script>
<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
